<template>
  <div>
    <div class="login_box">
        <div class="form_box">
            <p>登录</p>
            <div>
                <el-form ref="form" :model="form" label-width="100px">
                    <el-form-item label="用户名">
                      <el-input style="width:320px" v-model="form.username"></el-input>
                    </el-form-item>
                    <el-form-item label="密码">
                        <el-input type="password" style="width:320px" v-model="form.password" ></el-input>
                      </el-form-item>

                    <el-form-item>
                      <el-button type="primary" @click="onSubmit">登录</el-button>
                      <el-button>取消</el-button>
                    </el-form-item>
                  </el-form>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { loginApi } from '../apis/loginApi'
export default {
    data(){
        return{
            form:{
                username:'',
                password:''
            }
        }
    },
    methods:{
        onSubmit(){
            loginApi(this.form).then(res=>{
                if(res.code==1000){
                    localStorage.setItem('token',res.data.token)
                    this.$router.push('/Back')
                }
            })
        },
    }
};
</script>
<style lang="less" scoped>
.login_box{
   width: 100%;
   min-height: 100vh;
   background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    .form_box{
        width: 500px;
        height: 320px;
        border: 1px solid #eee;
        background-color: #ffffff;
        p{
            text-align:center;
        }
        /deep/.el-form{
            margin-top: 50px;
            button{
                border-radius: 11px;
            }
            .el-form-item__content button:nth-child(2) {
                margin-left: 130px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/login/index.vue